<button class="iackathon-preview-zoom-dialog__close-button"
        mat-dialog-close
        [matTooltip]="'generic.close' | translate"
        [attr.aria-label]="'generic.close' | translate">
    <mat-icon svgIcon="iackathon-preview-zoom-dialog__close"></mat-icon>
</button>

<img class="iackathon-preview-zoom-dialog__image"
     [src]="path"
     [alt]="'iackathon.image_deliverable' | translate">
